import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import { LoadingPane } from '~/components/loading-pane';
import { DeviceSettingsPageDocument } from '../queries/settings.generated';
import { Layout, SettingsForm } from './components';

export const DeviceSettings = () => {
  const params = useParams<{ deviceId: string }>();
  const deviceId = Number(params.deviceId);

  const { data, loading } = useQuery(DeviceSettingsPageDocument, {
    variables: { deviceId },
  });

  const device = data?.device;
  const propertyGroups = data?.propertyGroups ?? [];

  return (
    <Layout>
      <LoadingPane in={loading && !data} size={40} thickness={4}>
        {device && <SettingsForm device={device} propertyGroups={propertyGroups} />}
      </LoadingPane>
    </Layout>
  );
};
